import type {
  EmployeeUserWiseRow,
  UserSummaryStats,
} from '../types/employeeAnalysis'
import type { PeriodFilter } from './projectAnalysisPeriod'
import { getYearMonthKeysForFilter } from './projectAnalysisPeriod'

export function buildUserWiseRowsFromSummary(
  userSummary: UserSummaryStats | null,
  periodFilter: PeriodFilter,
): EmployeeUserWiseRow[] {
  if (!userSummary) return []
  const ymKeys = getYearMonthKeysForFilter(periodFilter)
  const byMonth = userSummary.by_year_month

  if (periodFilter && ymKeys?.length && byMonth) {
    const agg = new Map<number, EmployeeUserWiseRow>()
    for (const ym of ymKeys) {
      const users = byMonth[ym]
      if (!Array.isArray(users)) continue
      for (const u of users) {
        const id = u.user_id
        const existing = agg.get(id)
        const total = (u.total_hours ?? 0) + (existing?.total_hours ?? 0)
        const billable = (u.billable_hours ?? 0) + (existing?.billable_hours ?? 0)
        const nonBillable =
          (u.non_billable_hours ?? 0) + (existing?.non_billable_hours ?? 0)
        const isAct =
          existing !== undefined
            ? existing.is_active
            : u.is_active === 1 || u.is_active === true
        agg.set(id, {
          user_id: id,
          username: existing?.username ?? u.username,
          full_name: existing?.full_name ?? u.full_name,
          email: existing?.email ?? u.email,
          is_active: isAct,
          total_hours: Math.round(total * 100) / 100,
          billable_hours: Math.round(billable * 100) / 100,
          non_billable_hours: Math.round(nonBillable * 100) / 100,
          utilization_pct:
            total > 0 ? Math.round((billable / total) * 10000) / 100 : 0,
        })
      }
    }
    return Array.from(agg.values())
  }
  const list = userSummary.users ? [...userSummary.users] : []
  return list.map((u) => {
    const total = u.total_hours ?? 0
    const billable = u.billable_hours ?? 0
    const nonBill = u.non_billable_hours ?? 0
    return {
      user_id: u.user_id,
      username: u.username,
      full_name: u.full_name,
      email: u.email,
      is_active: u.is_active === 1 || u.is_active === true,
      total_hours: Math.round(total * 100) / 100,
      billable_hours: Math.round(billable * 100) / 100,
      non_billable_hours: Math.round(nonBill * 100) / 100,
      utilization_pct:
        total > 0 ? Math.round((billable / total) * 10000) / 100 : 0,
    }
  })
}
